import { extractApiErrorCodes } from "@/shared/lib/api-errors/api-error"
import type { ApiError } from "@/shared/lib/api/http"

/**
 * The i18n key explaining why a report was REFUSED, or null when the failure was a real failure.
 *
 * A refusal and an error arrive the same way — a rejected request — and telling them apart is the whole
 * difference between a product that looks governed and one that looks broken. The server says which by
 * sending a machine code rather than only a message.
 *
 * `BRANCH_FINANCE_NOT_DISCLOSABLE` and the branch-dimension refusal both mean: this cannot be shown, no
 * retry will change it, and the reason is a decision the church made rather than a fault.
 */
const REFUSAL_REASON_BY_CODE: Readonly<Record<string, string>> = Object.freeze({
  BRANCH_FINANCE_NOT_DISCLOSABLE: "finance.reports.locked.branchDimension",
})

export function resolveReportRefusalKey(error: unknown): string | null {
  if (!error || typeof error !== "object") return null

  for (const code of extractApiErrorCodes(error as ApiError)) {
    const reason = REFUSAL_REASON_BY_CODE[code]
    if (reason) return reason
  }

  return null
}
